import React, { ReactElement } from "react";
import oc from "open-color";

export default function AlarmPopup({
  label,
  value,
}: {
  label: string;
  value?: string;
}): ReactElement {
  return (
    <div
      className=""
      style={{
        zIndex: 100,
        position: "absolute",
        left: "0",
        right: "0",
        top: "0",
        bottom: "0",
        backgroundColor: oc.red[7],
        padding: "10px",
        borderRadius: "5px",
        color: "white",
        fontSize: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        lineHeight: "18px",
      }}
    >
      <div>
        <div>{label}</div>
        {value && <div style={{ fontWeight: "bold" }}>{value}</div>}
      </div>
    </div>
  );
}
